export function encodeLabelhash(hash) {
  return `[${hash.slice(2)}]`;
}
